(() => {
  'use strict';
  const state = window.RealmIntroduction;
  if (!state?.active || state.controllerAttached) return;
  state.controllerAttached = true;
  let ready = false;
  const disposals = [];
  const release = state.release;
  state.release = reason => { for (const dispose of disposals.splice(0)) dispose(); release(reason); };
  const finish = () => {
    if (!state.active || !ready || state.phase === 'fade') return;
    if (state.reducedMotion) { state.release('ready'); return; }
    if (state.visibleStarted === null) return;
    const remaining = 2400 - (performance.now() - state.visibleStarted);
    if (remaining > 0) { state.schedule(finish, Math.ceil(remaining)); return; }
    state.finish();
  };
  state.onVisible(finish);
  const onReady = () => {
    if (!state.active || document.readyState === 'loading') return;
    const main = document.getElementById('MainContent');
    const activeSlide = main?.querySelector('.realm-hero .swiper-slide-active');
    const image = Array.from(main?.querySelectorAll('.realm-hero img') || []).find(candidate => {
      const slide = candidate.closest('[data-hero-slide]');
      if (slide?.hidden || activeSlide && !activeSlide.contains(candidate)) return false;
      const rect = candidate.getBoundingClientRect();
      const style = getComputedStyle(candidate);
      return rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0 && rect.left < window.innerWidth && rect.right > 0 && style.display !== 'none' && style.visibility !== 'hidden';
    });
    if (!image || image.complete) {
      if (image && image.naturalWidth === 0) { state.release('image-error'); return; }
      ready = true;
      finish();
      return;
    }
    const onLoad = () => { ready = true; finish(); };
    const onError = () => state.release('image-error');
    image.addEventListener('load', onLoad, { once: true });
    image.addEventListener('error', onError, { once: true });
    disposals.push(() => image.removeEventListener('load', onLoad), () => image.removeEventListener('error', onError));
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
    disposals.push(() => document.removeEventListener('DOMContentLoaded', onReady));
  } else onReady();
})();
